// Correspondance routes héritées → routes canoniques R3.3 (miroir de backend/authz.py CANON_TO_LEGACY).
const MAP = [
  ["/auth/me", "/me"],
  ["/kobo/collect", "/me/kobo-collect"],
  ["/cases", "/strides/cas"],
  ["/projects/strides", "/strides/projet"],
  ["/projects/ghs", "/ghs/projet"],
  ["/projects/crisis", "/crisis/projet"],
  ["/dashboard", "/reponse/dashboard"],
  ["/alerts", "/reponse/alertes"],
  ["/coordination", "/reponse/coordination"],
  ["/projects", "/reponse/projets"],
  ["/indicators", "/reponse/indicateurs"],
  ["/matching", "/qualite/appariement"],
  ["/qc", "/qualite/qc"],
  ["/quality", "/qualite/gate"],
  ["/etl", "/qualite/etl"],
  ["/data", "/qualite/data"],
  ["/devices", "/qualite/devices"],
  ["/notebooks", "/qualite/notebooks"],
  ["/copilot", "/qualite/copilote"],
  ["/automation", "/rapports/automation"],
  ["/reports", "/rapports"],
  ["/dictionary", "/gouvernance/dictionnaire"],
  ["/zones", "/gouvernance/zones"],
  ["/aires", "/gouvernance/aires"],
  ["/agents", "/gouvernance/agents"],
  ["/governance", "/gouvernance"],
  ["/audit", "/admin/journal"],
  ["/users", "/admin/comptes"],
  ["/config", "/admin/config"],
  ["/kobo", "/admin/kobo"],
  ["/dhis2", "/admin/dhis2"],
  ["/backup", "/admin/sauvegardes"],
  ["/system", "/admin/systeme"],
  ["/codes", "/admin/codes"],
  ["/analytics", "/rapports/analytics"],
].sort((a, b) => b[0].length - a[0].length);

export function canonical(url) {
  if (!url || /^https?:/.test(url)) return url;
  const [path, qs] = url.split("?");
  for (const [legacy, canon] of MAP) {
    if (path === legacy || path.startsWith(legacy + "/")) {
      return canon + path.slice(legacy.length) + (qs ? "?" + qs : "");
    }
  }
  return url;
}
